import { render, staticRenderFns } from "./sales-order-edit.vue?vue&type=template&id=4a6c421e&scoped=true&"
import script from "./js/sales-order-edit.js?vue&type=script&lang=js&"
export * from "./js/sales-order-edit.js?vue&type=script&lang=js&"
import style0 from "./sales-order-edit.vue?vue&type=style&index=0&id=4a6c421e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6c421e",
  null
  
)

export default component.exports